
import { RouteCreateEditDirective } from './create-edit/routes-create-edit.directive'
import { RouteDetailsDirective } from './details/routes-details.directive'
import { RouteTrackingComponent } from './tracking/routes-tracking.component'

export const COMPONENTS_MODULE_NAME = 'simax.routes.components'
export const CREATE_EDIT_DIRECTIVE_NAME: string = 'routeCreateEdit'
export const DETAILS_DIRECTIVE_NAME: string = 'routeDetails'
export const TRACKING_DIRECTIVE_NAME: string = 'routeTracking'

const module = angular.module(COMPONENTS_MODULE_NAME, [])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new RouteDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new RouteCreateEditDirective()])
module.component(TRACKING_DIRECTIVE_NAME, new RouteTrackingComponent())
